import React from 'react'

import { Dialog } from "@blueprintjs/core";

const Carregando = ({isOpen}) => {
  return (
    <Dialog isOpen={isOpen} onClose={() => {}} canEscapeKeyClose={false} canOutsideClickClose={false}>
      <div className="pt-dialog-body">
        <div className="pt-non-ideal-state" style={{paddingTop: '10px'}}>
          <div className="pt-non-ideal-state-visual pt-non-ideal-state-icon">
            <div className="pt-spinner">
              <div className="pt-spinner-svg-container">
                <svg viewBox="0 0 100 100">
                  <path className="pt-spinner-track" d="M 50,50 m 0,-44.5 a 44.5,44.5 0 1 1 0,89 a 44.5,44.5 0 1 1 0,-89"></path>
                  <path className="pt-spinner-head" d="M 94.5 50 A 44.5 44.5 0 0 0 50 5.5"></path>
                </svg>
              </div>
            </div>
          </div>
          <h4 className="pt-non-ideal-state-title">Carregando...</h4>
        </div>
      </div>
    </Dialog>
  )
}

export default Carregando


// WEBPACK FOOTER //
// ./src/components/carregando/index.js